import * as ajax from "./ajax";
import { PATH } from "../constant";

const unloggedPage = ["/authentication/sign-in"]

export const autoLogin = async () => {
  let token = localStorage.getItem("jwt");
  
  // Se non c'è token, restituisci errore immediatamente
  if (!token || token === "" || token === "null") {
    return { error: "No token found" };
  }
       
  let config = {
    headers: new Headers({
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/x-www-form-urlencoded",
    }),
  };

  try {
    const response = await fetch(PATH + "users/me", {
      method: "GET",
      ...config
    });
    
    if (!response.ok) {
      return { error: "Authentication failed", status: response.status };
    }
    
    return await response.json();
  } catch (error) {
    return { error: "Network error", details: error };
  }
};


export const autoLoginError = () => {
    if (!unloggedPage.includes(window.location.pathname)) {
        return "/authentication/sign-in"
    }
    return window.location.pathname
};

export const autoLoginSuccess = () => {
    if (!unloggedPage.includes(window.location.pathname)) {
        return window.location.pathname
    }
    return "/dashboard"
};

export const saveLoginData = async (response) => {

    global.user = response;
    let token = localStorage.getItem("jwt");
    global.jwt = token;

    loadWorkerGlobal();
};

export const logout = () => {
    localStorage.setItem("jwt", "");
    global.user = null;
}

export const loadWorkerGlobal = async () => {
    let token = null;
    token = localStorage.getItem("jwt");

    let config = {
        headers: new Headers({
            //Authorization: `Bearer ${token}`,
            "Content-Type": "application/x-www-form-urlencoded",
        }),
    };

    return fetch(PATH + "operai-commesses?populate[commessa][fields][0]=nome&populate=operaio", config, {
        method: "GET",
    }).then((response) => response.json())

    //ajax.ajaxGetStrapi("operai-commesses?populate[commessa][fields][0]=nome", saveWorkersGlobal);
}

export const saveWorkerGlobal = (response) => {
    global.workers = response;
}

